export default __webpack_public_path__ + "images/background-dark.329181756ce54abf370757fef000396c.png";